import { useState, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/ui/primitives.tsx";

/** A memory file's text with its size and a save button (the panels around it say whose memory it is). */
export function MemoryEditor({ content, canEdit, saving, onSave, header }: { content: string; canEdit: boolean; saving: boolean; onSave: (content: string) => void; header?: ReactNode }) {
  const { t } = useTranslation();
  const [draft, setDraft] = useState<string | null>(null);
  const value = draft ?? content;
  const dirty = draft !== null && draft !== content;
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      {header}
      <textarea dir="auto" className="min-h-0 flex-1 resize-none bg-bg p-3 font-mono text-sm leading-6 focus:outline-none" placeholder={t("memory.placeholder")} value={value} readOnly={!canEdit} onChange={(e) => setDraft(e.target.value)} maxLength={32768} />
      <div className="flex items-center justify-between border-t border-border px-3 py-1.5 text-[11px] text-fg-muted">
        <span dir="ltr">{value.length.toLocaleString()} / 32,768</span>
        {canEdit && <Button size="sm" disabled={!dirty} loading={saving} onClick={() => { onSave(value); setDraft(null); }}>{t("common.save")}</Button>}
      </div>
    </div>
  );
}
